import { render, staticRenderFns } from "./ServiceSection.vue?vue&type=template&id=3339469a&scoped=true&"
import script from "./ServiceSection.vue?vue&type=script&lang=ts&"
export * from "./ServiceSection.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceSection.vue?vue&type=style&index=0&id=3339469a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3339469a",
  null
  
)

export default component.exports